import { CommunicationCenterOptionsActions } from "../datatableActionOptions/communication-center-options-actions";

export class CommunicationBulkAction
{
    constructor(router)
    {
        this.router = router
        this.communicationCenterOptionsActions = new CommunicationCenterOptionsActions(router);
    }

    bulk_mark_as_read(props)
    {
        
        props.confirmationModal.state = true;
        props.confirmationModal.message = 'Are you sure you want to mark as read this notification ? ';
        props.confirmationModal.confirm_btn_action = () => { this.communicationCenterOptionsActions.markAsRead(props) }
        props.setConfirmationModal(props.confirmationModal);
        props.setFlagForRerender(Math.random() * 10000);
        
    }

    bulk_mark_as_unread(props)
    {
        
        props.confirmationModal.state = true;
        props.confirmationModal.message = 'Are you sure you want to mark as unread this notification ? ';
        props.confirmationModal.confirm_btn_action = () => { this.communicationCenterOptionsActions.markAsUnread(props) };
        props.setConfirmationModal(props.confirmationModal);
        props.setFlagForRerender(Math.random() * 10000);
    }

    bulk_dismiss(props)
    {
        
        props.confirmationModal.state = true;
        props.confirmationModal.message = 'Are you sure you want to dismiss this notification ? ';
        props.confirmationModal.confirm_btn_action = () => { this.communicationCenterOptionsActions.dismiss(props) };
        props.setConfirmationModal(props.confirmationModal);
        props.setFlagForRerender(Math.random() * 10000);
    }

 
}